module.exports = __webpack_public_path__ + "img/memory_pc_hover.c94acf73.svg";